<template>
  <footer class="site-footer">
    <div class="container">
      <!-- Верхняя часть подвала: логотип и описание -->
      <div class="footer-top">
        <div class="footer-logo">
          <a href="/">
            <DefIcon name="shar" />
          </a>
        </div>
        <p class="footer-description">{{ $t('footer.description') }}</p>
        <div class="footer-social">
          <a
            href="https://pinterest.com/sharunstore/"
            target="_blank"
            aria-label="Pinterest"
            ><DefIcon name="pnts"
          /></a>
          <a
            href="https://t.me/sharunstore/"
            target="_blank"
            aria-label="Telegram"
            ><DefIcon name="tg"
          /></a>
          <a
            href="https://dzen.ru/sharunstore/"
            target="_blank"
            aria-label="Дзен"
            ><DefIcon name="dzen"
          /></a>
          <a
            href="https://youtube.com/sharuns-tore/"
            target="_blank"
            aria-label="Youtube"
            ><DefIcon name="youtube"
          /></a>
        </div>
      </div>

      <!-- Средняя часть: ссылки по категориям -->
      <div class="footer-links">
        <div class="footer-section">
          <h4>{{ $t('footer.about') }}</h4>
          <ul>
            <li><a :href="`${mainDomain}/about`">{{ $t('footer.links.about') }}</a></li>
            <li><a :href="`${mainDomain}/contacts`">{{ $t('footer.links.contacts') }}</a></li>
            <li><a :href="`${mainDomain}/privacy`">{{ $t('footer.links.privacy') }}</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>{{ $t('footer.buyers') }}</h4>
          <ul>
            <li><a :href="`${mainDomain}/payment`">{{ $t('footer.links.payment') }}</a></li>
            <li><a :href="`${mainDomain}/delivery`">{{ $t('footer.links.delivery') }}</a></li>
            <li><a :href="`${mainDomain}/returns`">{{ $t('footer.links.returns') }}</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>{{ $t('footer.partners') }}</h4>
          <ul>
            <li><a :href="`${mainDomain}/topartners`">{{ $t('footer.links.brands') }}</a></li>
            <li><a :href="`${mainDomain}/toauthors`">{{ $t('footer.links.authors') }}</a></li>
          </ul>
        </div>
      </div>

      <!-- Нижняя часть подвала: копирайт -->
      <div class="footer-bottom">
        <p>{{ $t('footer.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import DefIcon from "~/components/UI/Icons/DefIcon.vue";

const mainDomain = useRuntimeConfig().public.mainDomain;
</script>

<style scoped>
.site-footer {
  background-color: #ffffff;
  color: #121017;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  border-top: 1px solid #e5e5e5;
  padding: 60px 0 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 40px;
}

.footer-logo img {
  height: 36px;
}

.footer-description {
  flex: 1 1 400px;
  font-size: 14px;
  color: #121017;
  line-height: 1.6;
  margin: 0;
}

.footer-social a {
  margin-left: 16px;
  display: inline-block;
}

.footer-social img {
  width: 20px;
  height: 20px;
  transition: opacity 0.2s ease;
}

.footer-social a:hover img {
  opacity: 0.7;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  margin-bottom: 40px;
}

/* Основные блоки ссылок */
.footer-section {
  flex: 1 1 30%; /* Десктоп и планшет — три блока по ширине */
  min-width: 220px; /* Ограничение минимальной ширины блока */
}

.footer-section h4 {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section li {
  margin-bottom: 8px;
}

.footer-section a {
  text-decoration: none;
  color: #121017;
  transition: color 0.2s ease;
}

.footer-section a:hover {
  color: #555555;
}

.footer-bottom {
  text-align: center;
  font-size: 13px;
  color: #888888;
}

/* Мобильная версия: блоки на всю ширину */
@media (max-width: 767px) {
  .footer-links {
    flex-direction: column;
    gap: 24px;
  }
  .footer-section {
    flex: 1 1 100%;
  }
}

/* Планшетная версия: сохраняем три колонки */
@media (min-width: 768px) and (max-width: 1024px) {
  .footer-section {
    flex: 1 1 33.33%;
  }
}
</style>
